import { mergeObjectTypes } from '../cacheHelpers';

const Terminal = {
  merge: mergeObjectTypes
};

export default Terminal;
